export type RequestApiRouteConfig = {
    requestBasePath?: string;
    magicLinkBasePath?: string;
}

export const defaultRouteConfig: Required<RequestApiRouteConfig> = {
    requestBasePath: "api/request",
    magicLinkBasePath: "api/magic-link",
};

export const normalizeBasePath = (path: string): string => {
    return path.trim().replace(/^\/+|\/+$/g, "");
};

export const resolveRouteConfig = (config?: RequestApiRouteConfig): Required<RequestApiRouteConfig> => {
    const merged = { ...defaultRouteConfig, ...config };
    const requestBasePath = normalizeBasePath(merged.requestBasePath) || defaultRouteConfig.requestBasePath;
    const magicLinkBasePath = normalizeBasePath(merged.magicLinkBasePath) || defaultRouteConfig.magicLinkBasePath;
    return { requestBasePath, magicLinkBasePath };
};

export const getRequestBasePath = (config?: RequestApiRouteConfig): string => {
    return resolveRouteConfig(config).requestBasePath;
};
